import { useEffect, useState } from 'react';


const useLocalStorageTableCells = (keyName, defaultTableCells) => {
  const [headTableCells, setHeadTableCells] = useState(defaultTableCells);

  useEffect(() => {
    const storageTableCells = localStorage.getItem(keyName);
    let selectedCells = defaultTableCells;

    if (storageTableCells) {
      selectedCells = JSON.parse(storageTableCells);

      if (selectedCells.length !== defaultTableCells.length) {
        selectedCells = defaultTableCells.map((defaultCell) => {
          const storageCell = selectedCells.find((s) => defaultCell.label === s.label);

          return storageCell || defaultCell;
        });
      }
    }

    setHeadTableCells(selectedCells);
  }, [defaultTableCells]);

  return { headTableCells, setHeadTableCells };
};

export default useLocalStorageTableCells;
